import { absolutePath } from "./absolutePath";

export const contacts = {
  show: ({
    sqid,
    params = {},
  }: {
    sqid: string;
    params?: Record<string, any>;
  }) => absolutePath(`contacts/${sqid}`, params),

  update: ({
    sqid,
    params = {},
  }: {
    sqid: string;
    params?: Record<string, any>;
  }) => absolutePath(`contacts/${sqid}`, params),

  contactNotes: {
    index: ({
      contactSqid,
      params = {},
    }: {
      contactSqid: string;
      params?: Record<string, any>;
    }) => absolutePath(`contacts/${contactSqid}/contact_notes`, params),

    create: ({ contactSqid }: { contactSqid: string }) =>
      absolutePath(`contacts/${contactSqid}/contact_notes`, {}),

    update: ({ contactSqid, id }: { contactSqid: string; id: number }) =>
      absolutePath(`contacts/${contactSqid}/contact_notes/${id}`, {}),

    destroy: ({ contactSqid, id }: { contactSqid: string; id: number }) =>
      absolutePath(`contacts/${contactSqid}/contact_notes/${id}`, {}),
  },

  geoJson: (params: { force_refresh?: boolean } = {}) =>
    absolutePath("contacts/geo_json", params),

  bulkActions: {
    create: () => absolutePath("contacts/bulk_actions"),
  },
};
